import { createBrowserRouter } from "react-router-dom";

import { AdminLayout } from "../pages/_layouts/admin-layout";
import { AdminAnalyticsPage } from "../pages/analytics/page";
import { AdminAuditPage } from "../pages/audit/page";
import { AdminEditCampaignPage } from "../pages/campaigns/[id]/edit/page";
import { AdminCampaignDetailPage } from "../pages/campaigns/[id]/page";
import { AdminCreateCampaignPage } from "../pages/campaigns/new/page";
import { AdminCampaignsPage } from "../pages/campaigns/page";
import { AdminFeedbackDetailPage } from "../pages/feedback/[id]/page";
import { AdminFeedbackPage } from "../pages/feedback/page";
import { AdminLoginPage } from "../pages/login/page";
import { AdminOverviewPage } from "../pages/overview/page";
import { AdminRevenuePage } from "../pages/revenue/page";
import { AdminUserDetailPage } from "../pages/users/[id]/page";
import { AdminUsersPage } from "../pages/users/page";
import { AdminVerifyOtpPage } from "../pages/verify-otp/page";
import { AdminProviders } from "../providers";
import { AdminAuthGuard } from "./guards/auth";

export const router = createBrowserRouter([
  {
    element: <AdminProviders />,
    children: [
      { path: "/login", element: <AdminLoginPage /> },
      { path: "/verify-otp", element: <AdminVerifyOtpPage /> },
      {
        element: <AdminAuthGuard />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              { index: true, element: <AdminOverviewPage /> },
              { path: "campaigns", element: <AdminCampaignsPage /> },
              { path: "campaigns/new", element: <AdminCreateCampaignPage /> },
              { path: "campaigns/:id", element: <AdminCampaignDetailPage /> },
              { path: "campaigns/:id/edit", element: <AdminEditCampaignPage /> },
              { path: "feedback", element: <AdminFeedbackPage /> },
              { path: "feedback/:id", element: <AdminFeedbackDetailPage /> },
              { path: "users", element: <AdminUsersPage /> },
              { path: "users/:id", element: <AdminUserDetailPage /> },
              { path: "revenue", element: <AdminRevenuePage /> },
              { path: "analytics", element: <AdminAnalyticsPage /> },
              { path: "audit", element: <AdminAuditPage /> },
            ],
          },
        ],
      },
    ],
  },
]);
